import { render, staticRenderFns } from "./UserSalesWithStudentsSettingsTable.vue?vue&type=template&id=f6a15286&"
import script from "./UserSalesWithStudentsSettingsTable.vue?vue&type=script&lang=js&"
export * from "./UserSalesWithStudentsSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports